import * as types from "./types";
import { combineReducers } from "redux";
import orderBy from "lodash/orderBy";

function dataSaved(state = { status: false, msg: "" }, { type, payload }) {
  return type === types.DATA_SAVED
    ? payload
    : type === types.RESET_DATA_SAVED
      ? { status: false, msg: "" }
      : state;
}

function listaColegios(state = [], { type, payload }) {
  return type === types.FETCH_LISTA_COLEGIOS
    ? [
        ...state.filter(({ idColegio }) => idColegio !== payload.idColegio),
        payload
      ]
    : type === types.RESET_LISTA_COLEGIOS
      ? []
      : state;
}

function itemsTotales(state = 0, { type, payload }) {
  return type === types.ITEMS_TOTALES ? payload : state;
}

function paginasTotales(state = 0, { type, payload }) {
  return type === types.PAGINAS_TOTALES ? payload : state;
}

function itemsPorPagina(state = 20, { type, payload }) {
  return type === types.ITEMS_POR_PAGINA ? payload : state;
}

function paginaActual(state = 1, { type, payload }) {
  return type === types.PAGINA_ACTUAL ? payload : state;
}

function itemsInicialesPorPagina(state = [], { type, payload }) {
  return type === types.INICIOS_DE_PAGINA ? payload : state;
}

function colegioSeleccionado(state = null, { type, payload }) {
  return type === types.SELECCIONAR_COLEGIO
    ? payload
    : type === types.QUITAR_COLEGIO_SELECCIONADO
      ? null
      : state;
}

function accionesDeVenta(state = [], { type, payload }) {
  return type === types.ADDED_ACCIONES_VENTA
    ? orderBy(
        [
          ...state.filter(({ idAccion }) => idAccion !== payload.idAccion),
          payload
        ],
        ["timestamp"],
        ["desc"]
      )
    : type === types.REMOVED_ACCIONES_VENTA
      ? state.filter(({ idAccion }) => idAccion !== payload.idAccion)
      : type === types.CHANGED_ACCIONES_VENTA
        ? state.map(
            item => (item.idAccion === payload.idAccion ? payload : item)
          )
        : type === types.LIMPIAR_ACCIONES_VENTA
          ? []
          : state;
}

function tipoListado(state = "general", { type, payload }) {
  return type === types.TIPO ? payload : state;
}

function provinciaActiva(state = null, { type, payload }) {
  return type === types.SET_PROVINCIA_ACTIVA
    ? payload.toUpperCase()
    : type === types.RESET_PROVINCIA_ACTIVA
      ? null
      : state;
}

function nombreColegios(state = [], { type, payload }) {
  return type === types.OBTENER_NOMBRE_COLEGIOS
    ? payload
    : type === types.LIMPIAR_NOMBRE_COLEGIOS
      ? []
      : state;
}

function colegioBuscado(state = null, { type, payload }) {
  return type === types.SET_COLEGIO_BUSCADO
    ? payload
    : type === types.RESET_COLEGIO_BUSCADO
      ? null
      : state;
}

function localidades(state = [], { type, payload }) {
  return type === types.OBTENER_LOCALIDADES
    ? payload
    : type === types.LIMPIAR_LOCALIDADES
      ? []
      : state;
}

function localidadBuscada(state = null, { type, payload }) {
  return type === types.SET_LOCALIDAD
    ? payload
    : type === types.RESET_LOCALIDAD
      ? null
      : state;
}

const reducer = combineReducers({
  dataSaved,
  listaColegios,
  itemsTotales,
  paginasTotales,
  itemsPorPagina,
  paginaActual,
  itemsInicialesPorPagina,
  colegioSeleccionado,
  accionesDeVenta,
  tipoListado,
  provinciaActiva,
  nombreColegios,
  colegioBuscado,
  localidades,
  localidadBuscada
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/ventas/reducers.js